// Opening the chat's menu (the line under the box) from elsewhere, like the command bar, without loading the chat's code
// before it is wanted: the line opens it as soon as it is drawn (Features 4, Tidy).

export const CHAT_MENU_EVENT = "cb:chat-menu";

let wanted = false;

/** Opens the chat's menu: now, if the chat is drawn, or as soon as it is. */
export function openChatMenu() {
  wanted = true;
  window.dispatchEvent(new CustomEvent(CHAT_MENU_EVENT));
}

/** Whether the menu was asked for before the line was drawn; asking once clears it. */
export function takeChatMenuWish(): boolean {
  const was = wanted;
  wanted = false;
  return was;
}
